import { Controller } from "@hotwired/stimulus"
import { OrgChart } from "d3-org-chart"

export default class extends Controller {
  static targets = ["chart"]
  static values = { url: String }

  connect() {
    this.loadTree()
  }
  
  // Normalize long country names for compact UI display
  formatPlace(place) {
  if (!place) return ""

  return place
    .replace(/United States of America/gi, "USA")
    .replace(/United States/gi, "USA")
    .replace(/County/gi, "Co.")
}

  // Fetch nested tree JSON from Rails, flatten it into row-based data,
  // then hand it to d3-org-chart for rendering.

  async loadTree() {
    const response = await fetch(this.urlValue, {
      headers: { Accept: "application/json" }
    })

    if (!response.ok) {
      throw new Error(`Tree JSON request failed: ${response.status}`)
    }

    const data = await response.json()
    const rows = []
    this.flatten(data.node, null, rows)
    console.log("TREE JSON TEST", data.node)
    console.log("ALL ROW IDS", rows.map(r => r.id))

    const ids = rows.map(r => r.id)
    const dupes = ids.filter((id, i) => ids.indexOf(id) !== i)
    console.log("DUPLICATE IDS", dupes)
    
      const chart = new OrgChart()
      .container(this.chartTarget)
      .data(rows)
      .layout("bottom")
      .nodeId((d) => d.id)
      .parentNodeId((d) => d.parentId)
      // .nodeWidth(() => 260)
      // .nodeHeight(() => 160)
      // .nodeWidth(() => 300)
      // .nodeHeight(() => 175)
      .nodeWidth(() => 330)
      .nodeHeight(() => 190)
      .childrenMargin(() => 80)
      .compactMarginBetween(() => 20)
      .compactMarginPair(() => 40)
      // .initialZoom(0.8)
      .initialZoom(0.55)
      .duration(350)
    

          // Render each org-chart node card.
      // Data comes from tree_json -> flatten() -> d.data.
           // Render each org-chart node card.
      // Data comes from tree_json -> flatten() -> d.data.
      .nodeContent((d) => {
        const person = d.data
        const personUrl = `/people/${person.id}`
        const isDirectLine = d.depth <= 8

        // Preformatted life-date display from the backend concern/service layer.
        const lifeText = person.life_dates || ""

        // Keep birth/death places separate so identical places do not look like duplicates.
        // const birthPlaceText = person.birthPlace ? `b. ${person.birthPlace}` : ""
        // const deathPlaceText = person.deathPlace ? `d. ${person.deathPlace}` : ""
        const birthPlaceText = person.birthPlace ? `b. ${this.formatPlace(person.birthPlace)}` : ""
        const deathPlaceText = person.deathPlace ? `d. ${this.formatPlace(person.deathPlace)}` : ""
        const placeText = [birthPlaceText, deathPlaceText].filter(Boolean).join("<br>")
        const hasImage = !!person.image_url

      const imageHtml = hasImage ? `
        <img src="${person.image_url}" alt="" style="
          width:46px;
          height:46px;
          object-fit:cover;
          border-radius:8px;
          border:1px solid #d0d7de;
          margin:0 auto 6px auto;
          flex-shrink:0;
        ">
      ` : ""

        return `
          <a href="${personUrl}" style="
              display:flex;
              flex-direction:column;
              justify-content:space-between;
              width:${d.width}px;
              height:${d.height}px;
              padding:10px 12px;
              border-radius:10px;
              border:2px solid ${isDirectLine ? "#16a7c5" : "#d0d7de"};
              background:white;
              box-shadow:0 1px 3px rgba(0,0,0,0.08);
              text-align:center;
              font-size:15px;
              box-sizing:border-box;
              overflow:hidden;
              text-decoration:none;
              color:inherit;
              opacity:${isDirectLine ? "1" : "0.85"};
            ">
             ${imageHtml}
            <div style="
              font-weight:700;
              font-size:17px;
              line-height:1.25;   
              margin-bottom:6px;
              white-space:normal;
              color:#212529;
            ">
              ${person.name || "Unknown"}
            </div>

            <div style="
              font-size:13px;
              font-weight:500;
              color:#6c757d;
              line-height:1.2;
              margin-bottom:4px;
              min-height:14px;
            ">
              ${lifeText}
            </div>

            <div style="
              font-size:12px;
              color:#6c757d;
              line-height:1.2;
              margin-bottom:6px;
              white-space:normal;
              font-size:15px;
              line-height:1.2;
            ">
              ${placeText}
            </div>

            ${person.missingFather || person.missingMother ? `
            <div style="
              font-size:11px;
              font-weight:600;
              color:#17a2b8;
              line-height:1.2;
              letter-spacing:0.2px;
            ">
              ${person.missingFather ? "Father missing" : ""}
              ${person.missingFather && person.missingMother ? " • " : ""}
              ${person.missingMother ? "Mother missing" : ""}
            </div>
          ` : ""}
          </a>
        `
      })
   

      .onNodeClick((d) => {
        if (d && d.data && d.data.id) {
          window.location = `/people/${d.data.id}`
        }
      })

    chart.render().expandAll()
  }

  // Convert nested Rails tree JSON into the flat row structure expected by d3-org-chart.
  // We keep both display-ready fields (life_dates) and raw detail fields (birth/death place)
  // so the node card can stay simple without recalculating genealogy display logic in JS.
    // Convert nested Rails tree JSON into the flat row structure expected by d3-org-chart.
  // We keep both display-ready fields (life_dates) and raw detail fields (birth/death place)
  // so the node card can stay simple without recalculating genealogy display logic in JS.

  // NOTE:
// This tree data can contain shared ancestors (graph-like).
// d3 stratify requires unique IDs, so we skip duplicates here.
// This means some parent relationships may be dropped in visualization.
// This is intentional for now.

 flatten(node, parentId = null, rows = [], seen = new Set()) {
  if (!node) return

  const nodeId = String(node.id)
  if (seen.has(nodeId)) return
  seen.add(nodeId)

  rows.push({
    id: nodeId,
    parentId: parentId ? String(parentId) : "",
    name: node.display_name,
    birth: node.life_dates || "",
    birthDate: node.birth_date_text || "",
    deathDate: node.death_date_text || "",
    birthPlace: node.birth_place || "",
    deathPlace: node.death_place || "",
    image_url: node.image_url || null,
    // missingFather: !node.parents?.father?.node,
    // missingMother: !node.parents?.mother?.node
    missingFather: node.has_father === false,
    missingMother: node.has_mother === false
  })

  if (node.parents?.father?.node) {
    this.flatten(node.parents.father.node, node.id, rows, seen)
  }

  if (node.parents?.mother?.node) {
    this.flatten(node.parents.mother.node, node.id, rows, seen)
  }
}

// if (node.parents && node.parents.mother && node.parents.mother.node) {
//   this.flatten(node.parents.mother.node, node.id, rows)
// }
//   }
}